import { appData } from '@/mocks/home';

export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-900 text-background-100">
      <div className="px-4 md:px-6 max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full max-w-lg lg:max-w-none">
            <div className="relative">
              <div className="w-full aspect-[4/3] rounded-2xl overflow-hidden bg-background-800">
                <img
                  src="https://readdy.ai/api/search-image?query=Modern%20Chinese%20mobile%20app%20interface%20for%20video%20streaming%20platform%20showing%20drama%20listings%20on%20smartphone%20screen%2C%20dark%20theme%20with%20warm%20red%20accents%2C%20elegant%20UI%20design%2C%20cinematic%20aesthetic&width=600&height=450&seq=app-mockup&orientation=landscape"
                  alt="天美影视移动端界面预览"
                  className="w-full h-full object-cover"
                  loading="lazy"
                />
              </div>
            </div>
          </div>

          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-block text-xs font-semibold text-accent-400 bg-accent-500/20 px-3 py-1 rounded-full mb-4">
              移动追剧
            </span>
            <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-background-50 mb-4">
              {appData.title}
            </h2>
            <p className="text-sm md:text-base text-background-300 mb-6">
              {appData.subtitle}
            </p>

            <div className="grid grid-cols-2 gap-3 mb-8">
              {appData.features.map((f) => (
                <div key={f} className="flex items-center gap-2">
                  <div className="w-5 h-5 flex items-center justify-center rounded-full bg-primary-500/20 flex-shrink-0">
                    <i className="ri-check-line text-primary-400 text-xs"></i>
                  </div>
                  <span className="text-sm text-background-200">{f}</span>
                </div>
              ))}
            </div>

            <p className="text-sm text-background-400 mb-6">
              {appData.desc}
            </p>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <button className="w-full sm:w-auto px-7 py-3 text-sm font-semibold text-background-50 bg-primary-500 hover:bg-primary-600 rounded-lg transition-colors whitespace-nowrap cursor-pointer">
                <i className="ri-apple-line mr-2"></i>
                App Store 下载
              </button>
              <button className="w-full sm:w-auto px-7 py-3 text-sm font-semibold text-background-50 border border-background-500 hover:bg-background-800 rounded-lg transition-colors whitespace-nowrap cursor-pointer">
                <i className="ri-android-line mr-2"></i>
                安卓版下载
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}